import { Component, inject, input } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { first } from 'rxjs';
import { RestoreCaseDialogComponent } from 'src/app/helper/restore-case-dialog/restore-case-dialog.component';
import { CasesService } from 'src/app/services/cases/cases.service';
import { PayeeCasesService } from 'src/app/shared/payee-cases/payee-cases.service';
import { AdminCaseTableItem } from '../cases.component';
import { PayeeButtonComponent } from '../../../../shared/payee-buttons/payee-button/payee-button.component';

@Component({
  selector: 'app-is-deleted-column',
  templateUrl: './is-deleted-column.component.html',
  styleUrls: ['./is-deleted-column.component.scss'],
  imports: [PayeeButtonComponent],
})
export class IsDeletedColumnComponent {
  private dialog = inject(MatDialog);
  private casesService = inject(CasesService);
  private payeeCasesService = inject(PayeeCasesService);

  readonly element = input.required<AdminCaseTableItem>();

  restoreCase(): void {
    const element = this.element();
    const dialogRef = this.dialog.open(RestoreCaseDialogComponent, {
      data: element,
      position: {
        top: '50px',
      },
      autoFocus: false,
    });

    dialogRef
      .afterClosed()
      .pipe(first())
      .subscribe({
        next: async (data?: boolean) => {
          if (!data) {
            return;
          }

          try {
            await this.casesService.restoreCase(element.id);
            element.deleted_at = null;
            this.payeeCasesService.setCasesSubject.next();
          } catch (error) {
            console.error('Error while restoring case', error);
          }
        },
      });
  }
}
